/**
 * This tool will replace macros found inside a translation string, of the format
 * '{macro}' (standalone) or '{macro}text or other macros{/macro}', with either
 * strings or JSX elements. Macros that have no mapped handler are left as-is.
 */

import l10n = require('diy/util/l10n');

export type MacroReplacement = string|JSX.Element|(string|JSX.Element)[];
export type MacroSet = Map<
    string,
    (macroName: string, index: number, innerValue?: MacroReplacement)
        => string|JSX.Element
>;

export function processStringMacros(msgId: string, macros: MacroSet): (string|JSX.Element)[] {
    return processMacros(l10n.getString(msgId).split(/(\{[^}]+\})/), macros);
}

function processMacros(pieces: string[], macros: MacroSet): (string|JSX.Element)[] {
    const regOpenMacro = new RegExp("^{([a-zA-Z0-9-]+)}$");
    const regClosingMacro = new RegExp("^{/([a-zA-Z0-9-]+)}$");

    let output = pieces.slice();
    for (let i = 0; i < output.length; i++) {
        // if piece is a starting macro
        if (regOpenMacro.test(output[i])) {
            let macroName = output[i].match(regOpenMacro)[1];
            // if there's no handler defined for this macro, we just skip it
            if (!macros.has(macroName)) {
                continue;
            }
            // see if there's a matching closing macro, starting from the end
            let endMacroPos = output.indexOf('{/' + macroName + '}');
            // if no matching closing macro, consider this macro stand-alone
            if (-1 === endMacroPos || endMacroPos <= i) {
                output[i] = macros.get(macroName)(macroName, i, null) as string;
            } else { // if we found a closing macro
                // process everything in between the opening and closing macros
                let processedSlice = processMacros(output.slice(i + 1, endMacroPos), macros);
                // then pass the processed slice through the handler function
                let replacement = macros.get(macroName)(macroName, i, processedSlice) as string;
                // we replace the slice between the opening and closing macro
                // with the processed slice
                output.splice(i, endMacroPos - i + 1, replacement);
            }
        } else if (!regClosingMacro.test(output[i])) { // we ignore closing macros;
            // so this means that whatever is left is a regular string;
            // we decode HTML entities because React will escape them again
            output[i] = diy.editor.htmlDecode(output[i]);
        }
    }

    return output;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/l10nReactMacros.ts
 **/